import { useState } from "react";

export const useUserAuthenticated = () => {
  const [isAuthenticated] = useState(
    localStorage.getItem("arker_auth") !== null
  );

  return { isAuthenticated };
};
